import { render, staticRenderFns } from "./SNSList.vue?vue&type=template&id=0b189938"
import script from "./SNSList.vue?vue&type=script&lang=js"
export * from "./SNSList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports